import { useEffect, useState } from "react";
import Icon from "components/Elements/Icon/Icon";
import styles from "./styles.module.scss";

const Cursor = ({
  isHover,
  color,
  handleClick,
}: {
  isHover: boolean;
  color: string;
  handleClick: () => void;
}) => {
  const [cursorPosition, setCursorPosition] = useState({
    container: {},
    icon: {},
  });

  const positionElement = (e: MouseEvent) => {
    const mouseY = e.clientY;
    const mouseX = e.clientX;

    setCursorPosition((prev) => ({
      ...prev,
      container: { transform: `translate3d(${mouseX}px, ${mouseY}px, 0)` },
    }));
    setTimeout(() => {
      setCursorPosition((prev) => ({
        ...prev,
        icon: { transform: `translate3d(${mouseX}px, ${mouseY}px, 0)` },
      }));
    }, 30);
  };

  useEffect(() => {
    if (isHover) {
      window.addEventListener("mousemove", positionElement);

      return () => {
        window.removeEventListener("mousemove", positionElement);
      };
    }
  }, [isHover]);

  useEffect(() => {
    if (isHover) {
      window.addEventListener("click", handleClick);
      return () => {
        window.removeEventListener("click", handleClick);
      };
    }
  }, [isHover]);

  return isHover ? (
    <>
      <div className={styles.container} style={cursorPosition.container}></div>
      <div
        className={styles.icon}
        style={{ ...cursorPosition.icon, backgroundColor: color }}
      >
        <Icon name="play" white />
      </div>
    </>
  ) : null;
};

export default Cursor;
